// extracted by mini-css-extract-plugin
export default {"title":"ProgressBar_title__jESR7","counter":"ProgressBar_counter__6Z39x","labelWrapper":"ProgressBar_labelWrapper__qfPJ7","wrapper":"ProgressBar_wrapper__9xENF"};